import { fork, put, takeLatest } from 'redux-saga/effects';
import { getType } from '../../utils';
import actions from './actions';
export function* loadSelectedUserClients(api, action) {
    try {
        const { data } = yield api
            .getUserClients({
            id: action.payload.userId,
            clientId: action.payload.clientId,
        })
            .then((p) => p.request);
        yield put(actions.loadUserClientsSuccess(data));
    }
    catch (error) {
        yield put(actions.loadUserClientsError(true));
    }
}
export function* loadOneUserClient(api, action) {
    try {
        const { userId, clientId } = action.payload || {};
        const data = yield api
            .getOneUserClient({
            id: userId,
            clientId,
        })
            .then((p) => p.request);
        yield put(actions.loadOneUserClientSuccess(data));
    }
    catch (error) {
        yield put(actions.loadOneUserClientError(true));
    }
}
export function* updateUserClientSettings(api, action) {
    try {
        const { userId, clientId, settings } = action.payload || {};
        yield api
            .editUserSettings({
            id: userId,
            clientId,
            settings,
        })
            .then((p) => p.request);
        yield put(actions.updateUserClientSettingsSuccess(settings));
    }
    catch (error) {
        yield put(actions.updateUserClientSettingsError(true));
    }
}
export function* watchUserClients(api) {
    yield takeLatest(getType(actions.loadSelectedUserClients), loadSelectedUserClients, api);
}
export function* watchUserOneClient(api) {
    yield takeLatest(getType(actions.loadOneUserClient), loadOneUserClient, api);
}
export function* watchUpdateUserClientSettings(api) {
    yield takeLatest(getType(actions.updateUserClientSettings), updateUserClientSettings, api);
}
export const userClientsSagas = (api) => [
    fork(watchUserClients, api),
    fork(watchUserOneClient, api),
    fork(watchUpdateUserClientSettings, api),
];
export default userClientsSagas;
